import { ReviewCard } from '~/components/discussions/card/ReviewCard';
import { ReviewV2 } from '~/lib/discussions/types';
import { ReviewSkeleton } from './card/ReviewSkeleton';

import { useUserStatus } from '~/hooks/userStatus';

export function ReviewList({
  reviews,
  partnersIds = [],
  mutateComment,
  showAllReplies = false,
}: Readonly<{
  reviews: Array<ReviewV2>;
  partnersIds?: Array<number>;
  mutateComment?: () => void;
  showAllReplies?: boolean;
}>): JSX.Element {
  const { userStatus } = useUserStatus(reviews[0]?.deal_id);

  if (!reviews || reviews.length === 0) {
    return (
      <div className="flex flex-col gap-6">
        {Array.from({ length: 5 }).map((_, index) => (
          <ReviewSkeleton key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {reviews.map((review) => (
        <ReviewCard
          key={review.id}
          review={review}
          partnersIds={partnersIds}
          mutateComment={mutateComment}
          showCollapseIcon={userStatus?.user_moderator}
          expandCard={showAllReplies}
        />
      ))}
    </div>
  );
}
